import { api } from './client';

export type Direction = 'IN' | 'OUT';
export type MatchConfidence = 'EDRPOU' | 'IBAN' | 'NONE';

export interface StatementRow {
  line_number: number;
  date: string;
  direction: Direction;
  amount: string;
  counterparty_name: string | null;
  counterparty_edrpou: string | null;
  counterparty_iban: string | null;
  purpose: string | null;
  doc_number: string | null;
  doc_date: string | null;
  matched_contractor_id: string | null;
  matched_contractor_name: string | null;
  match_confidence: MatchConfidence;
  target_operation_type: string | null;
  duplicate_of_id: string | null;
  duplicate_of_kind: 'receipt' | 'payment' | null;
  duplicate_of_number: string | null;
  parse_error: string | null;
}

export interface StatementPreview {
  organization_id: string;
  bank_account_id: string;
  rows: StatementRow[];
  total_in: string;
  total_out: string;
  matched_count: number;
  unmatched_count: number;
  duplicate_count: number;
}

export interface ImportRowApply {
  line_number: number;
  skip: boolean;
  allow_duplicate?: boolean;
  direction: Direction;
  date: string;
  amount: string;
  contractor_id?: string | null;
  contract_id?: string | null;
  operation_type: string;
  purpose?: string | null;
  document_number?: string | null;
  incoming_doc_number?: string | null;
  incoming_doc_date?: string | null;
  payer_name?: string | null;
  payer_edrpou?: string | null;
  recipient_name?: string | null;
  recipient_edrpou?: string | null;
}

export interface ImportApplyResult {
  created_receipts: number;
  created_payments: number;
  skipped: number;
  skipped_as_duplicate: number;
  errors: string[];
  receipt_ids: string[];
  payment_ids: string[];
}

export const bankImport = {
  preview: async (
    organizationId: string,
    bankAccountId: string,
    file: File,
    format: 'canonical' | 'privatbank' = 'canonical',
  ): Promise<StatementPreview> => {
    const fd = new FormData();
    fd.append('organization_id', organizationId);
    fd.append('bank_account_id', bankAccountId);
    fd.append('file', file);
    fd.append('format', format);
    const { data } = await api.post<StatementPreview>('/bank-import/preview', fd);
    return data;
  },
  apply: async (
    organizationId: string,
    bankAccountId: string,
    rows: ImportRowApply[],
  ): Promise<ImportApplyResult> => {
    const { data } = await api.post<ImportApplyResult>('/bank-import/apply', {
      organization_id: organizationId,
      bank_account_id: bankAccountId,
      rows,
    });
    return data;
  },
};
